import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';

const googleId = process.env.REACT_APP_GOOGLE_ID
const primaryColor = process.env.REACT_APP_PRIMARY_COLOR || "#01bf9b"
const secondaryColor = process.env.REACT_APP_SECONDARY_COLOR || "#fff"

const theme = createMuiTheme({
    palette: {
        primary: {
            main: primaryColor,
            contrastText: secondaryColor,// The text color to use
        },
      secondary: {
        main: primaryColor,
        contrastText: secondaryColor// The text color to use
      },
    },
  });
ReactDOM.render(
  <GoogleOAuthProvider clientId={googleId}>
    <MuiThemeProvider theme={theme}>
        <App />
    </MuiThemeProvider>
  </GoogleOAuthProvider>
    ,document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
